import Vue from 'vue'
import moment from 'moment'
// import wp from '../modules/clients/wp'
// import bannerData from '@/data/banner.json'
import promoData from '@/data/promo.json'
import optionsData from '@/data/options.json';

// Single source of truth: the campaign whose window covers today, from the
// queue (falls back to the legacy single field). Both helpers below use it,
// so bundle pricing and course pricing always agree on which campaign is live.
function getActiveCampaign() {
  const now = new Date()
  const today = now.getFullYear() + '-' +
    String(now.getMonth() + 1).padStart(2, '0') + '-' +
    String(now.getDate()).padStart(2, '0')

  const list = Array.isArray(promoData.campaigns) && promoData.campaigns.length
    ? promoData.campaigns
    : (promoData.activeCampaign ? [promoData.activeCampaign] : [])

  for (let i = 0; i < list.length; i++) {
    const c = list[i]
    if (c && c.slug && c.startDate && c.endDate && today >= c.startDate && today <= c.endDate) {
      return c
    }
  }
  return null
}

function getActiveCampaignOffer(regionCode) {
  let rc = (regionCode || 'en').toLowerCase().trim()
  if (rc === 'uk') rc = 'en'
  else if (rc === 'us' || rc === 'en_us') rc = 'en-us'

  const campaign = getActiveCampaign()
  if (!campaign || !Array.isArray(campaign.offers)) return null

  const match = campaign.offers.find(item => item.code === rc)
  return match ? match.offer : null
}

// Campaign bundle override — global, not per region. Null when the live
// campaign has no bundle code set, so the standard global bundle stays in effect.
function getActiveCampaignBundle() {
  const campaign = getActiveCampaign()
  if (!campaign || !campaign.bundleCode) return null
  return {
    code:    campaign.bundleCode,
    amount:  campaign.bundleAmount,
    type:    campaign.bundleType || 'percentage',
    endDate: campaign.endDate || '',
  }
}

const d = {
  'TEFLORG': "£",
  'TEFLUS': "$",
  'IRELAND': "€",
  'CANADA': "CA$",
  'AUSTRALIA': "A$",
  'SOUTHAFRICA': "R",
}
const e = {
  'TEFLORG': "gb",
  'TEFLUS': "us",
  'EU': "eu",
  'IRELAND': "ie",
  'CANADA': "ca",
  'AUSTRALIA': "au",
  'SOUTHAFRICA': "za",
}
const f = {
  'TEFLORG': "GBP",
  'TEFLUS': "USD",
  'IRELAND': "EUR",
  'CANADA': "CAD",
  'AUSTRALIA': "AUD",
  'SOUTHAFRICA': "ZAR"
}
const g = {
  "GBP": 'TEFLORG',
  "USD": 'TEFLUS',
  'EUR': "IRELAND",
  'CAD': "CANADA",
  'AUD': "AUSTRALIA",
  'ZAR': "SOUTHAFRICA"
}
const m = {
  "asiamodal": 'GuidesTeflAsiaGuide',
  "worldmodal": 'GuidesTeflWorldGuide',
  'europemodal': "GuidesTeflEuropeGuide",
  'latinmodal': "GuidesTeflLatinAmericaGuide",
  'middleeastmodal': "GuidesTeflMiddleEastGuide",
  'onlinemodal': "GuidesTeflOnlineGuide",
  'brochuremodal': "FormsTeflBrochure",
  'podcast': "FormsPodcastNewsletter",
  'contactpodcast': "FormsContactPodcast"
}
const extName = {
  153: 'one week',
  154: 'one week',
  155: "one month",
  156: "one month",
  157: "two month",
  158: "two month",
  159: "three month",
  160: "three month",
}
const setRegions = [
  'AL', 'AD', 'AM', 'AT', 'BY', 'BE', 'BA', 'BG', 'CH', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FO', 'FI', 'FR', 'GE', 'GI', 'GR', 'HU', 'HR', 'IE', 'IS', 'IT', 'LI', 'LT', 'LU', 'LV', 'MC', 'MK', 'MT', 'NO', 'NL', 'PL', 'PT', 'RO', 'RS', 'RU', 'SE', 'SI', 'SK', 'SM', 'TR', 'UA', 'VA',
  'US',
  'CA',
  'AU', 'NZ',
  'GB',
  'CN',
  'ZA'
];

export default ({
  store,app
}) => {
  // PRICE DATA
  Vue.filter('priceData', (product) => {
    // DEFAULTS
    let priceText = ''
    let cost = 0
    let saleType = 'none'
    let priceDiscounted = 0
    let pricesDiscounted = []
    let offerCode = ''
    let offerEnds = ''
    let offerAmount = ''
    let discountType = ''
    let priceData = {}

    // We can just set this to be the product ID now the banner data is updated
    const postID = String(product.id)
    // Sometimes this is prices sometimes just price?
    product.prices = product.prices || product.price

    // CONSTS
    const l = store.state.cart.price_label !== '' ? store.state.cart.price_label : store.state.cart.defaultPriceLabel
    const price = product.prices.filter(price => price.label === l)
    // Add default in case regional pricing isn't set up
    const h = product.prices.filter(price => price.label === 'DEFAULT')
    const currency = f[l]

    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
    });

    // Get the current region code from the Vuex store
    // Regions are now expected to be directly 'en', 'en-us', etc., no further normalization needed.
    const userRegionCode = store.state.user.userRegion === 'default' ? store.state.geolocation.detectedRegion : store.state.user.userRegion;

    // Use promoData imported directly from the JSON file
    const promotionSettings = promoData;

    // Find the relevant regional settings
    let regionalSettings = null;
    if (promotionSettings && promotionSettings.regions && Array.isArray(promotionSettings.regions)) {
        // Directly use userRegionCode as it's now expected to match the promoData keys
        regionalSettings = promotionSettings.regions.find(r => r.code === userRegionCode);
    }

    // Fallback to 'en' (which was 'uk') or first available if no specific region match
    if (!regionalSettings && promotionSettings && promotionSettings.regions && promotionSettings.regions.length > 0) {
        regionalSettings = promotionSettings.regions.find(r => r.code === 'en') || promotionSettings.regions[0]; // Fallback to 'en'
    } else if (!regionalSettings) {
        // If no regions data at all, provide a safe empty structure
        regionalSettings = {
            standardOffer: {},
            specialOffer: {}
        };
    }

    // Extract relevant offer data from the found regional settings and global settings
    const currentStandardOffer = regionalSettings.standardOffer || {};
    const currentSpecialOffer = regionalSettings.specialOffer || {};
    // Ensure globalBundleSettings correctly refers to the top-level structure of promoData
    const globalBundleSettings = promotionSettings || {};

    // Extract coursesOnSale arrays
    const standardCoursesOnSale = currentStandardOffer.coursesOnSale || [];
    const specialCoursesOnSale = currentSpecialOffer.coursesOnSale || [];
    const specialOfferEnabled = currentSpecialOffer.enabled || false;


    // Get the original cost of product in correct currency
    if (price[0]) {
        cost = parseFloat(price[0].cost)
        priceText = formatter.format(cost)
    } else if (h[0]) {
        cost = parseFloat(h[0].cost)
        priceText = formatter.format(cost)
    } else {
        cost = 0; // Fallback if no price available
        priceText = formatter.format(0);
    }

    const campaignOffer = getActiveCampaignOffer(userRegionCode)
    const campaignCoursesOnSale = campaignOffer?.coursesOnSale || []

    // Let's get the data we need...
    if (product.id === 20100) { // Hardcode 90% off for Ultimate TEFL Resource Pack
      saleType = 'PDFBUNDLE'
      offerCode = 'PDFBUNDLE90' // needs a matching code on the server
      offerAmount = 90
      for (const p of product.prices) {
          const fullCost = Math.round(p.cost * 100) / 100
          const discountedCost = Math.round((fullCost * ((100 - offerAmount) / 100)) * 100) / 100
          const discountValue = discountedCost === fullCost ? 0 : fullCost - discountedCost
          const discountPercentage = offerAmount // For percentage, the amount *is* the percentage
          pricesDiscounted.push({
              id: p.id,
              label: p.label,
              fullCost,
              cost: discountedCost,
              discountAmount: discountValue,
              discountPercentage,
              code: offerCode,
              ends: offerEnds,
          })
      }
    }

    // BUNDLES — campaign bundle override takes precedence over the global bundle
    else if (product.type === 'bundle' && (
        (getActiveCampaignBundle() && getActiveCampaignBundle().code) ||
        (globalBundleSettings.globalBundleCode && globalBundleSettings.globalBundleAmount)
    )) {
        const campaignBundle = getActiveCampaignBundle()
        const useCampaign    = !!(campaignBundle && campaignBundle.code)

        saleType     = 'BUNDLE'
        discountType = useCampaign ? (campaignBundle.type || 'percentage') : globalBundleSettings.globalBundleType
        offerCode    = (useCampaign ? campaignBundle.code : globalBundleSettings.globalBundleCode).toUpperCase()
        offerEnds    = useCampaign ? (campaignBundle.endDate || '') : '2099-12-12'
        offerAmount  = parseFloat(useCampaign ? campaignBundle.amount : globalBundleSettings.globalBundleAmount)

        if (discountType === 'flatdiscount') {
            for (const p of product.prices) {
                const fullCost = Math.round(p.cost * 100) / 100
                const discountedCost = Math.round((fullCost - offerAmount) * 100) / 100
                const discountValue = discountedCost === fullCost ? 0 : fullCost - discountedCost
                const discountPercentage = discountedCost === fullCost ? 0 : Math.round(((fullCost - discountedCost) / fullCost) * 100)
                pricesDiscounted.push({
                    id: p.id,
                    label: p.label,
                    fullCost,
                    cost: discountedCost,
                    discountAmount: discountValue,
                    discountPercentage,
                    code: offerCode,
                    ends: offerEnds,
                })
            }
        } else if (discountType === 'percentage') {
            for (const p of product.prices) {
                const fullCost = Math.round(p.cost * 100) / 100
                const discountedCost = Math.round((fullCost * ((100 - offerAmount) / 100)) * 100) / 100
                const discountValue = discountedCost === fullCost ? 0 : fullCost - discountedCost
                const discountPercentage = offerAmount // For percentage, the amount *is* the percentage
                pricesDiscounted.push({
                    id: p.id,
                    label: p.label,
                    fullCost,
                    cost: discountedCost,
                    discountAmount: discountValue,
                    discountPercentage,
                    code: offerCode,
                    ends: offerEnds,
                })
            }
        }
    }

    // CAMPAIGN OFFER — takes priority over SP and STD
    else if (campaignOffer && campaignCoursesOnSale.includes(postID)) {
        saleType = 'CAMPAIGN'
        discountType = campaignOffer.discountType  || 'percentage'
        offerCode    = campaignOffer.offerCode     ? campaignOffer.offerCode.toUpperCase() : ''
        offerEnds    = ''
        offerAmount  = parseFloat(campaignOffer.discountAmount || 0)

        if (discountType === 'flatdiscount') {
            for (const p of product.prices) {
                const fullCost = Math.round(p.cost * 100) / 100
                const discountedCost = Math.round((fullCost - offerAmount) * 100) / 100
                const discountValue = discountedCost === fullCost ? 0 : fullCost - discountedCost
                const discountPercentage = discountedCost === fullCost ? 0 : Math.round(((fullCost - discountedCost) / fullCost) * 100)
                pricesDiscounted.push({ id: p.id, label: p.label, fullCost, cost: discountedCost, discountAmount: discountValue, discountPercentage, code: offerCode, ends: offerEnds })
            }
        } else if (discountType === 'percentage') {
            for (const p of product.prices) {
                const fullCost = Math.round(p.cost * 100) / 100
                const discountedCost = Math.round((fullCost * ((100 - offerAmount) / 100)) * 100) / 100
                const discountValue = discountedCost === fullCost ? 0 : fullCost - discountedCost
                const discountPercentage = offerAmount
                pricesDiscounted.push({ id: p.id, label: p.label, fullCost, cost: discountedCost, discountAmount: discountValue, discountPercentage, code: offerCode, ends: offerEnds })
            }
        }
    }

    // Check if this course is on special offer (using the new `enabled` flag and coursesOnSale)
    else if (specialOfferEnabled && specialCoursesOnSale.includes(postID)) {
        saleType = 'SPECIAL'
        discountType = currentSpecialOffer.discountType
        offerCode = currentSpecialOffer.offerCode ? currentSpecialOffer.offerCode.toUpperCase() : '';
        // Use 'saleDays' instead of 'dateText'
        offerEnds = currentSpecialOffer.saleDays ? currentSpecialOffer.saleDays.join(',') : '';
        offerAmount = parseFloat(currentSpecialOffer.discountAmount || 0);

        if (discountType === 'flatdiscount') {
            for (const p of product.prices) {
                const fullCost = Math.round(p.cost * 100) / 100
                const discountedCost = Math.round((fullCost - offerAmount) * 100) / 100
                const discountValue = discountedCost === fullCost ? 0 : fullCost - discountedCost
                const discountPercentage = discountedCost === fullCost ? 0 : Math.round(((fullCost - discountedCost) / fullCost) * 100)
                pricesDiscounted.push({
                    id: p.id,
                    label: p.label,
                    fullCost,
                    cost: discountedCost,
                    discountAmount: discountValue,
                    discountPercentage,
                    code: offerCode,
                    ends: offerEnds,
                })
            }
        } else if (discountType === 'percentage') {
            for (const p of product.prices) {
                const fullCost = Math.round(p.cost * 100) / 100
                const discountedCost = Math.round((fullCost * ((100 - offerAmount) / 100)) * 100) / 100
                const discountValue = discountedCost === fullCost ? 0 : fullCost - discountedCost
                const discountPercentage = offerAmount
                pricesDiscounted.push({
                    id: p.id,
                    label: p.label,
                    fullCost,
                    cost: discountedCost,
                    discountAmount: discountValue,
                    discountPercentage,
                    code: offerCode,
                    ends: offerEnds,
                })
            }
        }
    }
    // Check if this course is on standard offer
    else if (standardCoursesOnSale.includes(postID)) {
        saleType = 'STANDARD'
        discountType = currentStandardOffer.discountType
        offerCode = currentStandardOffer.offerCode ? currentStandardOffer.offerCode.toUpperCase() : '';
        // Use 'saleDays' instead of 'dateText'
        offerEnds = currentStandardOffer.saleDays ? currentStandardOffer.saleDays.join(',') : '';
        offerAmount = parseFloat(currentStandardOffer.discountAmount || 0);

        if (discountType === 'flatdiscount') {
            for (const p of product.prices) {
                const fullCost = Math.round(p.cost * 100) / 100
                const discountedCost = Math.round((fullCost - offerAmount) * 100) / 100
                const discountValue = discountedCost === fullCost ? 0 : fullCost - discountedCost
                const discountPercentage = discountedCost === fullCost ? 0 : Math.round(((fullCost - discountedCost) / fullCost) * 100)
                pricesDiscounted.push({
                    id: p.id,
                    label: p.label,
                    fullCost,
                    cost: discountedCost,
                    discountAmount: discountValue,
                    discountPercentage,
                    code: offerCode,
                    ends: offerEnds,
                })
            }
        } else if (discountType === 'percentage') {
            for (const p of product.prices) {
                const fullCost = Math.round(p.cost * 100) / 100
                const discountedCost = Math.round((fullCost * ((100 - offerAmount) / 100)) * 100) / 100
                const discountValue = discountedCost === fullCost ? 0 : fullCost - discountedCost
                const discountPercentage = offerAmount
                pricesDiscounted.push({
                    id: p.id,
                    label: p.label,
                    fullCost,
                    cost: discountedCost,
                    discountAmount: discountValue,
                    discountPercentage,
                    code: offerCode,
                    ends: offerEnds,
                })
            }
        }
    } else {
        // Product not on sale
        priceDiscounted = cost
        pricesDiscounted = product.prices.map(p => ({
            id: p.id,
            label: p.label,
            fullCost: parseFloat(p.cost),
            cost: parseFloat(p.cost),
            discountAmount: 0,
            discountPercentage: 0,
            code: '',
            ends: '',
        }));
    }

    // Determine final priceDiscounted for the *current* currency (from price[] or h[])
    // This is important because `pricesDiscounted` now holds all currencies.
    const currentPriceObject = pricesDiscounted.find(p => p.label === l) || pricesDiscounted.find(p => p.label === 'DEFAULT');
    priceDiscounted = currentPriceObject ? currentPriceObject.cost : cost; // Fallback to original cost if no discounted price found

    const finalDiscountAmount = priceDiscounted === cost ? 0 : cost - priceDiscounted;
    const finalDiscountPercentage = priceDiscounted === cost ? 0 : Math.round(((cost - priceDiscounted) / cost) * 100);

    priceData = {
        postID,
        sku: product.id,
        productName: product.name,
        productType: product.type,
        productDescription: product.description,
        priceEcommerce: cost, // Original price for current currency
        displayPrice: priceText, // Formatted original price for current currency
        discountPrice: priceDiscounted, // Discounted price for current currency
        pricesDiscounted, // Array of all discounted prices
        originalPrice: cost, // Original price for current currency
        discountAmount: finalDiscountAmount, // Discount amount for current currency
        discountPercentage: finalDiscountPercentage, // Discount percentage for current currency
        discountType,
        saleType,
        offerCode,
        offerEnds,
        product,
        page: product.page // Assuming product.page is still relevant and comes from product
    }

    return priceData
})
  // RETURN FIELD
  Vue.filter('outputField', (data,fieldName) => {
    return data[fieldName]
  })
  // Convet Modal class
  Vue.filter('convertModal', (string) => {
    if(m[string]){
    return m[string]
    }
    return string
  })
  // Extension Name from ID
  Vue.filter('extensionFromId', (id) => {
    return extName[id]
  })
  // RETURN FIELD
  Vue.filter('formatPercent', (number) => {
    const formatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
   });
   // console.log(price)
    return Number(formatter.format(number))
  })

  // NEW REGION STUFF
  Vue.filter('regionToShow', function(region) {
    const regionMap = {
      'en-us': 'en_us',
      'ca': 'ca',
      'au': 'au',
      'za': 'za',
      'ie': 'ie'
    };

    return regionMap[region?.toLowerCase()] || 'en';
  });

  // CURRENCIES
  Vue.filter('priceFromLabel', ( prices) => {
    const detectedCountry = store.state.geolocation.detectedCountry || 'US'; // Default to 'US' if region is not detected
    // const l = store.state.cart.price_label !== '' ? store.state.cart.price_label : defaultPriceLabel
    const l = store.state.cart.price_label !== '' ? store.state.cart.price_label : store.state.cart.defaultPriceLabel
    const price = prices.filter(price => price.label === l)
    // Add default in case regional pricing isn't set up
    const h = prices.filter(price => price.label === 'DEFAULT')
    const currency = f[l]
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
    });

    let formattedPrice = '';
    if (price[0]) {
      formattedPrice = formatter.format(price[0].cost);
    } else {
      formattedPrice = formatter.format(h[0].cost);
    }

    // Append the currency if the detected region is not the US
    if (!setRegions.includes(detectedCountry)) {
      formattedPrice += ` ${currency}`;
    }

    return formattedPrice;
  })
  Vue.filter('priceFromLabelNumber', (prices) => {
    // const defaultCurrency = store.state.geolocation.detectedCurrency || app.$cookies.get('tefl_geolocation_currency') || 'GBP'
    // const defaultPriceLabel = g[defaultCurrency]
    // const l = store.state.cart.price_label !== '' ? store.state.cart.price_label : defaultPriceLabel
    const l = store.state.cart.price_label !== '' ? store.state.cart.price_label : store.state.cart.defaultPriceLabel
    const price = prices.filter(price => price.label === l)
    // Add default in case regional pricing isn't set up
    const h = prices.filter(price => price.label === 'DEFAULT')
    if (price[0])
      return price[0].cost
    else
      return h[0].cost
  })
  Vue.filter('discountAmountFromLabel', (prices) => {
    // const defaultCurrency = store.state.geolocation.detectedCurrency || app.$cookies.get('tefl_geolocation_currency') || 'GBP'
    // const defaultPriceLabel = g[defaultCurrency]
    const detectedCountry = store.state.geolocation.detectedCountry || 'US'; // Default to 'US' if region is not detected
    // const l = store.state.cart.price_label !== '' ? store.state.cart.price_label : defaultPriceLabel
    const l = store.state.cart.price_label !== '' ? store.state.cart.price_label : store.state.cart.defaultPriceLabel
     const price = prices.filter(price => price.label === l)
     // Add default in case regional pricing isn't set up
     const h = prices.filter(price => price.label === 'DEFAULT')
     const currency = f[l]
     const formatter = new Intl.NumberFormat('en-US', {
       style: 'currency',
       currency,
     });

     let formattedPrice = '';
     if (price[0]) {
       formattedPrice = formatter.format(price[0].discountAmount);
     } else {
       formattedPrice = formatter.format(h[0].discountAmount);
     }

     // Append the currency if the detected region is not the US
     if (!setRegions.includes(detectedCountry)) {
       formattedPrice += ` ${currency}`;
     }

     return formattedPrice;
   })
  Vue.filter('discountPercentageFromLabel', (prices) => {
    // const defaultCurrency = store.state.geolocation.detectedCurrency || app.$cookies.get('tefl_geolocation_currency') || 'GBP'
    // const defaultPriceLabel = g[defaultCurrency]
    // const l = store.state.cart.price_label !== '' ? store.state.cart.price_label : defaultPriceLabel
    const l = store.state.cart.price_label !== '' ? store.state.cart.price_label : store.state.cart.defaultPriceLabel
     const price = prices.filter(price => price.label === l)
    // Add default in case regional pricing isn't set up
    const h = prices.filter(price => price.label === 'DEFAULT')
    if (price[0])
      return price[0].discountPercentage
    else
      return h[0].discountPercentage
  })
  Vue.filter('flagFromLabel', (label,countrycode) => {
    const country = store.state.geolocation.detectedCountry
    // const region = store.state.user.userRegion === 'default' ? store.state.geolocation.detectedRegion : store.state.user.userRegion
    const regionClicked = store.state.cart.regionClicked
    const defaultCurrency = store.state.geolocation.detectedCurrency || app.$cookies.get('tefl_geolocation_currency') || 'GBP'
    const defaultPriceLabel = g[defaultCurrency]
    let l = store.state.cart.price_label !== '' ? store.state.cart.price_label : defaultPriceLabel
    const europeRegion = ['AL','AD','AM','AT','BY','BE','BA','BG','CH','CY','CZ','DE','DK','EE','ES','FO','FI','FR','GB','GE','GI','GR','HU','HR','IE','IS','IT','LI','LT','LU','LV','MC','MK','MT','NO','NL','PL','PT','RO','RS','RU','SE','SI','SK','SM','TR','UA','VA',]
    // const americaRegion = ["US","AU","CA"]
    // const ukRegion = ["GB"]
    // const asiaRegion = ["CN"]
    // const africaRegion = ["ZA"]

    // console.log('flagfromllabel', {
    //   priceLabel_l: l, 
    //   detectedCountry: country,
    //   countrycode,
    //   regionClicked,
    //   finalCondition: (l === 'TEFLUS' && country !== 'US') || regionClicked === 'ROW'
    // });

    if (l === 'IRELAND'){
      country === 'IE' ? l = 'IRELAND' : l = 'EU'
    }
    if (regionClicked === 'EU'){
      l = 'EU'
    }
    if (regionClicked === 'IRELAND'){
      l = 'IRELAND'
    }
    if((l === 'TEFLUS' && country !== 'US') || regionClicked === 'ROW' || (country === '' && regionClicked === '') ){
      let flag = countrycode.toUpperCase();
      if (flag === 'GB' || flag === 'AU' || flag === 'US' || flag === 'ZA' || flag === 'CA' || flag === 'IE' || europeRegion.includes(flag) || flag === ''){
        flag = 'globe'
        if(regionClicked === 'TEFLUS'){
          flag = 'us'
        }
      }
      return 'fi-' + flag.toLowerCase()
    }

    return 'fi-' + e[l]
  })
  Vue.filter('currencyFromLabel', (label) => {
    // const defaultCurrency = store.state.geolocation.detectedCurrency || app.$cookies.get('tefl_geolocation_currency') || 'GBP'
    // const defaultPriceLabel = g[defaultCurrency]
    // const l = store.state.cart.price_label !== '' ? store.state.cart.price_label : defaultPriceLabel
    const l = store.state.cart.price_label !== '' ? store.state.cart.price_label : store.state.cart.defaultPriceLabel
    return d[l]
  })
  Vue.filter('labelFromCurrency', (currency) => {
    const c = currency
    return g[c]
  })
  Vue.filter('currencyCodeFromLabel', (label) => {
    // const defaultCurrency = store.state.geolocation.detectedCurrency || app.$cookies.get('tefl_geolocation_currency') || 'GBP'
    // const defaultPriceLabel = g[defaultCurrency]
    // const l = store.state.cart.price_label !== '' ? store.state.cart.price_label : defaultPriceLabel
    const l = store.state.cart.price_label !== '' ? store.state.cart.price_label : store.state.cart.defaultPriceLabel
    return f[l]
  })
  // Create our number formatter.
  Vue.filter('formatAsPrice', (price) => {
    // const defaultCurrency = store.state.geolocation.detectedCurrency || app.$cookies.get('tefl_geolocation_currency') || 'GBP'
    // const defaultPriceLabel = g[defaultCurrency]
    // const l = store.state.cart.price_label !== '' ? store.state.cart.price_label : defaultPriceLabel
    const l = store.state.cart.price_label !== '' ? store.state.cart.price_label : store.state.cart.defaultPriceLabel
    const currency = f[l]
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
    });
   // console.log(price)
    return formatter.format(price)
  })
  // Create our number formatter.
  Vue.filter('twoDecimalPlaces', (number) => {
    const formatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
   });
   // console.log(price)
    return Number(formatter.format(number))
  })

  Vue.filter('timeago', (date) => {
    const newdate = new Date(date)
    const seconds = Math.floor((new Date() - newdate) / 1000);
    let interval = Math.floor(seconds / 31536000);
    if (interval > 1) {
      return interval + " years";
    }
    interval = Math.floor(seconds / 2592000);
    if (interval > 1) {
      return interval + " months";
    }
    interval = Math.floor(seconds / 86400);
    if (interval > 1) {
      return interval + " days";
    }
    interval = Math.floor(seconds / 3600);
    if (interval > 1) {
      return interval + " hours";
    }
    interval = Math.floor(seconds / 60);
    if (interval > 1) {
      return interval + " minutes";
    }
    return Math.floor(seconds) + " seconds";
  })
  Vue.filter('cdn', (url) => {
    // console.log('CDN', url)
    // const imgRegex = /[^\s]+(.*?).(jpg|jpeg|JPG|JPEG)$/;
    const d = url.match(/^.*\/\/[^/]+/)
    // const img = url.match(imgRegex)
    let result;
    if (d)
      result = url.replace(/^.*\/\/[^/]+/, 'https://cdn-wp.tefl.org')
    else
      result = 'https://cdn-wp.tefl.org' + url
    // if (img)
      // result = result+'.webp'
    // console.log('CDN result',result)
    return result
  })
  Vue.filter('toRelative', (url) => {
    const d = url.match(/^.*\/\/[^/]+/)
    if (d)
      return url.replace(/^.*\/\/[^/]+/, '')
    else
      return url
  })
  // DATES
  Vue.filter('formatDate', (date, format) => {
    // console.log ('DATE TO CONVERT', date)
    if (date !== null && date !== ''){
      if (!date.endsWith("00")) {
        date = date + ' 23:59:59'
      }
      // const isDST = moment.tz(moment(), 'Europe/London').isDST();
      // CONVERSION NOT NEEDED HERE
      // let dateTime
      /*
      if (isDST) {
        dateTime = moment(date).subtract(1, 'hours').utc().format(format)
      } else {
        dateTime = moment(date).utc().format(format)
      }
      */
      const dateTime = moment(date).utc().format(format)
      // console.log('CONVERTED DATE', dateTime)
      return dateTime
    } else {
      return null
    }
  })
  Vue.filter('niceDate', (date) => {
    let formattedDate
    // Add endOf day to Fix midnight tonight issue
    if(moment(date).endOf("day").diff(moment(), 'hours') > 24) {
      formattedDate = moment(date).format('MMMM Do')+'.'
    } else if(moment(date).endOf("day").diff(moment(), 'hours') < 24 && moment(date).endOf("day").diff(moment(), 'hours') > 0) {
      formattedDate = 'midnight tonight!'
    } else {
      formattedDate = 'Offer has ended'
    }
    return formattedDate
  })
  Vue.filter('convertDate', (date, format) => {

    const isDST = moment.tz(moment(date), 'Europe/London').isDST();
    const city = store.state.geolocation.detectedCity
    // return moment.tz.guess();
    const start = moment.tz(date, 'Europe/London')
    const tz = store.state.geolocation.detectedTimezone
    const niceTz = tz.substring(tz.indexOf('/') + 1);
    niceTz.replace(/_/g, ' ');
    let dateTime
    if (isDST) {
      dateTime = moment.tz(start, tz).subtract(1, 'hours').format(format)
    } else {
      dateTime = moment.tz(start, tz).format(format)
    }
    return '<strong>' + city + ': </strong>' + dateTime
  })
  Vue.filter('isDST', (text) => {
    const isDST = moment.tz(moment(), 'Europe/London').isDST();
    let tz = text
    if (isDST) {
      tz = 'BST'
    } else {
      tz = 'GMT'
    }
    return tz
  })
  Vue.filter('convertDateSimple', (date, format) => {

    const isDST = moment.tz(moment(date), 'Europe/London').isDST();
    // const city = store.state.geolocation.detectedCity
    const start = moment.tz(date, 'Europe/London')
    const tz = store.state.geolocation.detectedTimezone
    let dateTime
    if (isDST) {
      dateTime = moment.tz(start, tz).subtract(1, 'hours').format(format)
    } else {
      dateTime = moment.tz(start, tz).format(format)
    }
    return dateTime
  })
  Vue.filter('isDST', (text) => {
    const isDST = moment.tz(moment(), 'Europe/London').isDST();
    let tz = text
    if (isDST) {
      tz = 'BST'
    } else {
      tz = 'GMT'
    }
    return tz
  })
  // Find urls and make them clickable links
  Vue.filter('replaceURLs', (message) => {
    if (!message) return;

    const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
    const emailRegex = /(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/g
    message = message.replace(urlRegex, function (url) {
      let hyperlink = url;
      if (!hyperlink.match('^https?://')) {
        hyperlink = 'http://' + hyperlink;
      }
      return '<a href="' + hyperlink + '" target="_blank" rel="noopener noreferrer">' + url + '</a>'
    });
    message = message.replace(emailRegex, function (url) {

      return '<a href="mailto:' + url + '" target="_blank" rel="noopener noreferrer">' + url + '</a>'
    })
    return message
  })
  // MISC
  Vue.filter('extensionName', (name) => {
    return name.slice(19, -13)
  })
  Vue.filter('fixtabname', (name, isVirtual, linebreak) => {
    if (isVirtual && linebreak)
      return name.replace(/(\d{1,3}-hour)/g, '$1<br />Virtual')
    else if (isVirtual)
      return name.replace(/(\d{1,3}-hour)/g, '$1 Virtual')
    else
      return name.replace(/(\d{1,3}-hour)/g, '$1')
  })
  Vue.filter('capitalise', (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  })
  Vue.filter('courseFeatures', (region, hours, type) => {
    hours = parseInt(hours)
    let featureArray;
    // standard
    if (region === 'us') {
      featureArray = [
        'The TEFL Org’s internationally recognized BAC and SQA center accreditation',
        'Internationally recognised TEFL certificate issued by The TEFL Org',
        'Lifetime TEFL Resume support',
        'Lifetime access to our TEFL Jobs Center',
        'Downloadable TEFL coursebook'
      ]
    } else {
      featureArray = [
        'The TEFL Org’s internationally recognised BAC and SQA centre accreditation',
        'Internationally recognised TEFL certificate issued by The TEFL Org',
        'Lifetime TEFL CV support',
        'Lifetime access to our TEFL Jobs Centre',
        'Downloadable TEFL coursebook'
      ]
    }

    // type
    if (type === 'online course') {
      featureArray.push('Personal online TEFL tutor')
      // hours
      switch (true) {
        case hours === 200:
          featureArray.push('7 months to complete your online work')
          featureArray.splice(1, 0, 'Recognised by the US & English governments: DEAC AQC approved and Ofqual regulated');
          break;
        case hours === 168:
          featureArray.push('7 months to complete your online work')
          featureArray.splice(1, 0, 'Recognised by the US & English governments: DEAC AQC approved and Ofqual regulated');
          break;
        case hours === 120:
          featureArray.push('6 months to complete your online work')
          featureArray.splice(1, 0, 'Recognised by the US government: DEAC AQC approved');
          break;
        case hours === 100:
          featureArray.push('5 months to complete your online work');
          break;
        case hours === 80:
          featureArray.push('4 months to complete your online work');
          break;
        case hours === 50:
          featureArray.push('3 months to complete your online work');
          break;
      }
    } else {
      switch (true) {
        case hours > 190:
          featureArray.push('Personal online TEFL tutor', '7 months to complete your online work');
          featureArray.splice(1, 0, 'Recognised by the US & English governments: DEAC AQC approved and Ofqual regulated');
          break;
        case hours <= 190 && hours > 160:
          featureArray.push('Personal online TEFL tutor', '7 months to complete your online work');
          featureArray.splice(1, 0, 'Recognised by the US & English governments: DEAC AQC approved and Ofqual regulated');
          break;
        case hours <= 150 && hours > 140:
          featureArray.push('Personal online TEFL tutor', '6 months to complete your online work', 'Recognised by the US government: DEAC AQC approved');
          break;
        case hours <= 140 && hours > 130:
          featureArray.push('Personal online TEFL tutor', '6 months to complete your online work', 'Recognised by the US government: DEAC AQC approved');
          break;
        case hours === 130:
          featureArray.push('Personal online TEFL tutor', '5 months to complete your online work', 'Recognised by the US government: DEAC AQC approved');
          break;
        case hours === 120:
          featureArray.push('Personal online TEFL tutor', '6 months to complete your online work', 'Recognised by the US government: DEAC AQC approved');
          break;
        case hours < 120 && hours > 60:
          featureArray.push('Personal online TEFL tutor', '5 months to complete your online work', 'Recognised by the US government: DEAC AQC approved');
          break;


      }
    }
    return featureArray
  })
  Vue.filter('courseModules', (virtual, hours, type) => {
    hours = parseInt(hours)
    const moduleArray = []
    // standard

    // type
    if (type === 'online course') {

      // hours
      switch (true) {
        case hours === 200:
          moduleArray.push('<strong>Level 5:</strong> 100 hours - TEFL Methodology', '<strong>Level 5:</strong> 80 hours - English Language and Grammar', '10 hours - Telephone Teaching', '10 hours - Teaching Large Classes')
          break;
        case hours === 168:
          moduleArray.push('<strong>Level 5:</strong> 100 hours - TEFL Methodology', '<strong>Level 5:</strong> 80 hours - English Language and Grammar', '10 hours - Telephone Teaching', '10 hours - Teaching Large Classes')
          break;
        case hours === 120:
          moduleArray.push('50 hours - TEFL Methodology', '30 hours - English Language and Grammar', '20 hours - Video Observation', '10 hours - Telephone Teaching', '10 hours - Teaching Large Classes');
          break;
        case hours === 100:
          moduleArray.push('50 hours - TEFL Methodology', '30 hours - English Language and Grammar', '20 hours - Video Observation');
          break;
        case hours === 80:
          moduleArray.push('50 hours - TEFL Methodology', '30 hours - English Language and Grammar');
          break;
        case hours === 50:
          moduleArray.push('50 hours - TEFL Methodology');
          break;
      }
    } else {
      switch (true) {
        case hours > 229:
        if (!virtual) {
          moduleArray.push('30 hour practical classroom TEFL course');
        } else {
          moduleArray.push('30 hour practical <strong>virtual</strong> classroom TEFL course held over Zoom');
        }
        moduleArray.push('<strong>Level 5:</strong> 100 hours - TEFL Methodology', '<strong>Level 5:</strong> 80 hours - English Language and Grammar', '10 hours - Telephone Teaching', '10 hours - Teaching Large Classes');
        break;
        case hours <= 229 && hours > 200:

        if (!virtual) {
          moduleArray.push('20 hour practical classroom TEFL course');
        } else {
          moduleArray.push('20 hour practical <strong>virtual</strong> classroom TEFL course held over Zoom');
        }
        moduleArray.push('<strong>Level 5:</strong> 100 hours - TEFL Methodology', '<strong>Level 5:</strong> 80 hours - English Language and Grammar', '10 hours - Telephone Teaching', '10 hours - Teaching Large Classes');
        break;
        case hours <= 200 && hours > 190:

          if (!virtual) {
            moduleArray.push('30 hour practical classroom TEFL course');
          } else {
            moduleArray.push('30 hour practical <strong>virtual</strong> classroom TEFL course held over Zoom');
          }
          moduleArray.push('<strong>Level 5:</strong> 79 hours - TEFL Methodology', '30 hours - English Language and Grammar', '20 hours - Video Observation', '<strong>Level 5:</strong> 19-hours - The Principles of Teaching English as a Foreign Language Course', '10 hours - Telephone Teaching', '10 hours - Teaching Large Classes');
          break;
        case hours <= 190 && hours > 160:
          if (!virtual) {
            moduleArray.push('20 hour practical classroom TEFL course');
          } else {
            moduleArray.push('20 hour practical <strong>virtual</strong> classroom TEFL course held over Zoom');
          }
          moduleArray.push('<strong>Level 5:</strong> 79 hours - TEFL Methodology', '30 hours - English Language and Grammar', '20 hours - Video Observation', '<strong>Level 5:</strong> 19-hours - The Principles of Teaching English as a Foreign Language Course', '10 hours - Telephone Teaching', '10 hours - Teaching Large Classes');
          break;
        case hours <= 150 && hours > 140:
          if (!virtual) {
            moduleArray.push('30 hour practical classroom TEFL course');
          } else {
            moduleArray.push('30 hour practical <strong>virtual</strong> classroom TEFL course held over Zoom');
          }
          moduleArray.push('50 hours - TEFL Methodology', '30 hours - English Language and Grammar', '20 hours - Video Observation', '10 hours - Telephone Teaching', '10 hours - Teaching Large Classes');
          break;
        case hours <= 140 && hours > 130:
          if (!virtual) {
            moduleArray.push('20 hour practical classroom TEFL course');
          } else {
            moduleArray.push('20 hour practical <strong>virtual</strong> classroom TEFL course held over Zoom');
          }
          moduleArray.push('50 hours - TEFL Methodology', '30 hours - English Language and Grammar', '20 hours - Video Observation', '10 hours - Telephone Teaching', '10 hours - Teaching Large Classes');

          break;
        case hours === 130:
          if (!virtual) {
            moduleArray.push('30 hour practical classroom TEFL course');
          } else {
            moduleArray.push('30 hour practical <strong>virtual</strong> classroom TEFL course held over Zoom');
          }
          moduleArray.push('50 hours - TEFL Methodology', '30 hours - English Language and Grammar', '20 hours - Video Observation');
          break;
        case hours < 130 && hours > 60:
          if (!virtual) {
            moduleArray.push('20 hour practical classroom TEFL course');
          } else {
            moduleArray.push('20 hour practical <strong>virtual</strong> classroom TEFL course held over Zoom');
          }
          moduleArray.push('50 hours - TEFL Methodology', '30 hours - English Language and Grammar', '20 hours - Video Observation');
          break;
        case hours <= 60 && hours > 30:
          if (!virtual) {
            moduleArray.push('30 hour practical classroom TEFL course');
          } else {
            moduleArray.push('30 hour practical <strong>virtual</strong> classroom TEFL course held over Zoom');
          }
          moduleArray.push('30 hours - English Language and Grammar');
          break;
        case hours <= 30 && hours > 20:
          if (!virtual) {
            moduleArray.push('30 hour practical classroom TEFL course');
          } else {
            moduleArray.push('30 hour practical <strong>virtual</strong> classroom TEFL course held over Zoom');
          }
          break;
        case hours <= 20 && hours > 10:
          if (!virtual) {
            moduleArray.push('20 hour practical classroom TEFL course');
          } else {
            moduleArray.push('20 hour practical <strong>virtual</strong> classroom TEFL course held over Zoom');
          }
          break;
        case hours <= 10:

          moduleArray.push('Online classroom TEFL course');

          break;

      }
    }
    return moduleArray
  })
  Vue.filter('classAvailability', (value) => {
    let spaces_text;
    switch (true) {
      case value <= 0:
        spaces_text = 'SOLD OUT';
        break;
      case value === 1:
        spaces_text = '1 place remaining';
        break;

      case value <= 4:
        spaces_text = value + ' places remaining';
        break;

      case value <= 8:
        spaces_text = 'Limited availability';
        break;

      default:
        spaces_text = 'Good availability';
        break;

    }

    return spaces_text
  })

  Vue.filter('isBST',(date) => {
    function lastSunday(month, year) {
      const dt = new Date()
      const lastDayOfMonth = new Date(
        Date.UTC(year || dt.getFullYear(), month + 1, 0)
      )
      const day = lastDayOfMonth.getDay()
      return new Date(
        Date.UTC(
          lastDayOfMonth.getFullYear(),
          lastDayOfMonth.getMonth(),
          lastDayOfMonth.getDate() - day
        )
      )
    }
    const d = date || new Date();
    const starts = lastSunday(2, d.getFullYear())
    starts.setHours(1)
    const ends = lastSunday(9, d.getFullYear())
    ends.setHours(1)
    return d.getTime() >= starts.getTime() && d.getTime() < ends.getTime()
  })
}
Vue.filter('localTimezone', (timezone) => {
  const tz = moment.tz(moment(), timezone).format('z');
  return tz
})
Vue.filter('timeAgo', (date) => {
  const timeAgo = moment(date).fromNow();
  return timeAgo
})
Vue.filter('zerofill', function (value) {
  // returns a single number with added 0 i.e 9 becomes 09
  return ( value < 10 && value > -1 ? '0' : '' ) + value;
});
Vue.filter('truncateString',function (value, num) {
  value = value.charAt(0).toUpperCase() + value.slice(1);
  if (value.length <= num) {
    return value
  }
  return value.slice(0, num) + '...'
})
Vue.filter('noStudents',(number) => {
  // console.log('noStudents filter', number)
  return optionsData.number_students
})
Vue.filter('roundScore',(number) => {
  return Math.round(number * 10) / 10
})
Vue.filter('capitalizeWords', (str) => {
  console.log("String to convert: "+str);
  if (!str) return '';
  return str
    .toLowerCase()
    .split(' ')
    .map(function(word) {
        console.log("First capital letter: "+word[0]);
        console.log("remain letters: "+ word.substr(1));
        return word[0].toUpperCase() + word.substr(1);
    })
    .join(' ');
})
